var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categoryContainer"},[_c('scroller',{attrs:{"lock-y":"","scrollbar-x":false}},[_c('div',{staticClass:"categoryRow"},_vm._l((_vm.categoryList),function(item){return _c('div',{staticClass:"categoryItem",on:{"click":function($event){_vm.onClick(item.ID)}}},[_c('span',[_vm._v(_vm._s(_vm.getTranslation(item,'name')))])])}))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602632b8","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/CategoryList.vue
// module id = null
// module chunks = 